import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../components/buttons';
import { Field, reduxForm } from 'redux-form';
import { renderAutoCompleteSingleSelect } from '../../../components/reduxFields';
import { getSoapAction } from './soap/actions/soapActions';
import { connect } from 'react-redux';

class ConfirmationPopUpModal extends Component{
    constructor(props) {
      super(props);
        this.state ={
            open: true,
            disableConfirmBtn:true,
            soapNotes:null
        }
      };


      componentDidMount(){
      //   this.props.getSoapAction(this.props.apptid,this.props.encounterId,this.props.isAdminUpdateAfterRendered)
      //   if(this.props.get_soap.data.soapNotes) this.setState({soapNotes:this.props.get_soap.data.soapNotes})

      //   if(this.props.get_soap.data.sessionNotes_BCBA_Default){
      //      let default_bcba_notes = {
      //       "peoplePresentParticipate": this.props.get_soap.data.sessionNotes_BCBA_Default.peoplePresentParticipate,
      //       "settingEventReported": this.props.get_soap.data.sessionNotes_BCBA_Default.settingEventReported,
      //       "atypicalBehaviorsReported": this.props.get_soap.data.sessionNotes_BCBA_Default.atypicalBehaviorsReported,
      //       "clientResponseToSignificantOthers": this.props.get_soap.data.sessionNotes_BCBA_Default.clientResponseToSignificantOthers,
      //       "clientConcernsReported": this.props.get_soap.data.sessionNotes_BCBA_Default.clientConcernsReported,
      //       "narrativeSummary": this.props.get_soap.data.sessionNotes_BCBA_Default.bcbA_Default_Assessment.narrativeSummary,
      //       "modificationOrDirection": this.props.get_soap.data.sessionNotes_BCBA_Default.bcbA_Default_Assessment.modificationOrDirection
      //      }
      //     this.setState({soapNotes:default_bcba_notes})
      //   }  

      //   if(this.props.get_soap.data.sessionNotes_BT_Default){
      //     let default_bt_notes = {
      //      "peoplePresentParticipate": this.props.get_soap.data.sessionNotes_BT_Default.peoplePresentParticipate,
      //      "settingEventReported": this.props.get_soap.data.sessionNotes_BT_Default.settingEventReported,
      //      "atypicalBehaviorsReported": this.props.get_soap.data.sessionNotes_BT_Default.atypicalBehaviorsReported,
      //      "clientResponseToSignificantOthers": this.props.get_soap.data.sessionNotes_BT_Default.clientResponseToSignificantOthers,
      //      "narrativeSummary": this.props.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment.narrativeSummary,
      //     }
      //    this.setState({soapNotes:default_bt_notes})
      //  }  
         
      }

      handleClose = () => {
        if (this.state.open) {
          this.setState({ open: false });
          this.props.closeDialog();
        };
      };

      onSubmitHandler(formData) {
        let formProps = this.props.formProps()
        console.log("formProps from cpum",formProps);
        
        this.props.onCompleteSoap(formProps)
        this.handleClose();
      };
      
      

      handleReasonSelection = (input,selected)=>{
        if (selected.value!==1 && selected.value!==2 && selected.value!==3) {
          this.setState({disableConfirmBtn:true})
          return;
        }
        this.props.noteDataGetter(this.state.soapNotes)
        this.setState({disableConfirmBtn:false})
        input.onChange(selected.value)
        this.props.sendReason(selected.label)
        
      }

     
      render(){
        const { handleSubmit } = this.props;
        let submitButton = this.state.disableConfirmBtn ?
        <SubmitButtonModalDisabled label="Confirm" /> :
        <SubmitButtonModal label="Confirm" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}/>;
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
            submitButton,
          ];
        return (
          <Dialog className="custom_modal"
          title = 'Confirmation popup'
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}>
            <div className='row mt-5'>
              <div className='row'>
                <div className='col-sm-6 require'>
                  <p>Reason for rendering from Web : </p>
                </div>
                <div className='col-sm-6 require'>
                  <Field
                    name="Reason Code"
                    label="Reason Code"
                    options={[{id:1,value:"Staff forgot to clock in/clock out"},{id:2,value:"Cell phone not charged"},{id:3,value:"No cell coverage"}]}
                    handleNewRequest={this.handleReasonSelection}
                    component={renderAutoCompleteSingleSelect}
                    required={true}
                    />
                </div>
              </div>
                
            </div>
           
          </Dialog>
        )
      }
}

const mapStateToProps = (state) =>{
  
  return {
    get_soap: state.soap.get_soap,
  }
}

ConfirmationPopUpModal = reduxForm({
    form: 'ConfirmationPopUpModal',
    // validate,
    enableReinitialize: true,
})(ConfirmationPopUpModal);

export default connect(mapStateToProps, {getSoapAction})(ConfirmationPopUpModal);


// WEBPACK FOOTER //
// ./src/modules/scheduling/components/confirmationPopUpModal.js